module.exports = __webpack_public_path__ + "static/img/logo20201205.27e9ad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/logo20201205.png
// module id = EQcd
// module chunks = 23